import { render, staticRenderFns } from "./ServiceBoardCard.vue?vue&type=template&id=1ed2a3ab&scoped=true&"
import script from "./ServiceBoardCard.vue?vue&type=script&lang=ts&"
export * from "./ServiceBoardCard.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceBoardCard.vue?vue&type=style&index=0&id=1ed2a3ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2a3ab",
  null
  
)

export default component.exports